import React from 'react';
import Device from "../../../devices/device";
import {DOWN, UP} from "../../RibbonNew/constants";

// Estilo reutilizable para el elemento focusable del placeholder
const FOCUSABLE_STYLE = {
  display: 'block',
  height: '1px',
  opacity: 0,
  overflow: 'hidden'
};

/**
 * Administra la virtualización de ribbons para PS4.
 * Solo renderiza los ribbons cercanos al ribbon enfocado,
 * reemplazando los lejanos con placeholders livianos para reducir nodos DOM.
 */
class PS4RibbonLazy {
  constructor(options = {}) {
    this._isEnabled = Device.getDevice().getPlatform() === 'ps4';
    this._ribbonHeightEstimate = options.ribbonHeightEstimate || 220;
    this._visibleDistance = options.visibleDistance || 3;
    this._renderedRibbons = null;
    this._isMounted = false;
    this._focusHandler = null;
    this._getFocusedIndex = options.getFocusedIndex || (() => 0);
    this._setFocusedIndex = options.setFocusedIndex || (() => {
    });
    this._setScrollDown = (indexRibbon, ribbonsIds) => {this.setScrollDown(indexRibbon, ribbonsIds)}
    this._setScrollUp = (indexRibbon, ribbonsIds) => this.setScrollUp(indexRibbon, ribbonsIds);

    if (this._isEnabled) {
      // Arrow function para mantener la referencia a 'this' sin depender de .bind()
      this._focusHandler = () => {
        if (!this._isMounted) return;
        this._trackFocusedRibbon();
      };
    }
  }

  /** Indica si la virtualización está activa (solo en PS4) */
  get isEnabled() {
    return this._isEnabled;
  }

  /** Llamar en componentDidMount */
  onMount() {
    this._isMounted = true;
  }

  /** Llamar en componentWillUnmount */
  onUnmount() {
    this._isMounted = false;
  }

  /** Agregar listener de seguimiento de foco en document */
  addFocusListener() {
    if (this._isEnabled && this._focusHandler) {
      document.addEventListener('sn:focused', this._focusHandler);
    }
  }

  /** Remover listener de seguimiento de foco de document */
  removeFocusListener() {
    if (this._focusHandler) {
      document.removeEventListener('sn:focused', this._focusHandler);
    }
  }

  /** Guardar referencia de ribbons construidos en render */
  setRibbons(ribbons) {
    this._renderedRibbons = ribbons;
  }

  /** Determinar si un ribbon debe renderizarse completo o ser placeholder */
  isRibbonVisible(index) {
    if (!this._isEnabled) return true;
    const distance = Math.abs(index - this._getFocusedIndex());
    return distance <= this._visibleDistance;
  }

  /** Crear elemento placeholder liviano para ribbon virtualizado */
  createPlaceholder(ribbon, index) {
    return (
      <div
        key={ribbon.id || index}
        id={ribbon.id}
        style={{height: this._ribbonHeightEstimate + 'px', overflow: 'hidden'}}
      >
        <a className="focusable" style={FOCUSABLE_STYLE}/>
      </div>
    );
  }

  /**
   * Rastrear el ribbon enfocado recorriendo el DOM hacia arriba
   * desde el elemento activo hasta encontrar un id que coincida con un ribbon.
   */
  _trackFocusedRibbon() {
    const ribbons = this._renderedRibbons;
    if (!ribbons) return;
    const active = document.activeElement;
    if (!active) return;
    // Recorrer el DOM hacia arriba desde el elemento enfocado para encontrar el ribbon
    let el = active;
    let depth = 15;
    while (el && depth-- > 0) {
      if (el.id && typeof el.id === 'string') {
        for (let i = 0; i < ribbons.length; i++) {
          if (ribbons[i].id === el.id) {
            // Solo actualizar si cambió el índice para evitar re-renders innecesarios
            if (this._getFocusedIndex() !== i) {
              this._setFocusedIndex(i);
            }
            return;
          }
        }
      }
      el = el.parentNode;
    }
  }
}

export default PS4RibbonLazy;



// WEBPACK FOOTER //
// ./src/components/RibbonGridNew/PS4/PS4RibbonLazy.js